import React, { useEffect, useState } from "react";
import Card from "./card/card";
import backGround from "../../Pyragon/03.png";
import $ from "jquery";

import "./our-team.css";


import Cardone from '../../site/content/card_one.json'
import Cardtwo from '../../site/content/card_two.json'
import Cardthree from '../../site/content/card_three.json'
import Cardfour from '../../site/content/card_four.json'
import Cardfive from '../../site/content/card_five.json'
import Cardsix from '../../site/content/card_six.json'
import Cardseven from '../../site/content/card_seven.json'
import Cardeight from '../../site/content/card_eight.json'

import Flip from 'react-reveal/Flip';

const OurTeam = () => {
  const [changepos, setChangePos] = useState(0);
  
  useEffect(() => {
    let oldVal = 0;

    $("div").on("wheel", function (e) {
      if (e.originalEvent.deltaX < 0) {
                oldVal += 2;
        setChangePos(oldVal);
      } else if(e.originalEvent.deltaX > 0){
        oldVal -= 2;
            setChangePos(oldVal);
      }
    });
  }, []);

  return (
      <div id="main-container-our-team">
            {/* <img class="demo-bg-ourteam" src={backGround} alt="" style={{left : changepos}}/> */}

        <h1>OUR TEAM</h1>
        <div id="our-team-card-container">
          <Flip left>
          <Card name={Cardone['full_name']} description={Cardone["description"]}/>
          </Flip>
          <Flip left>
          <Card name={Cardtwo["full_name"]} description={Cardtwo["description"]}/>
          </Flip>
          <Flip left>
          <Card name={Cardthree["full_name"]} description={Cardthree["description"]}/>
          </Flip>
          <Flip left>
          <Card name={Cardfour["full_name"]} description={Cardfour["description"]}/>
          </Flip>
          <Flip left>
          <Card name={Cardfive["full_name"]} description={Cardfive["description"]}/>
          </Flip>
          <Flip left>
          <Card name={Cardsix["full_name"]} description={Cardsix["description"]}/>
          </Flip> 
          {/*<Flip left>
          <Card name={Cardseven["full_name"]} description={Cardseven["description"]}/>
          </Flip> 
          <Flip left>
          <Card name={Cardeight["full_name"]} description={Cardeight["description"]}/>
          </Flip> */}   
          </div>
      </div>
  );
};

export default OurTeam;
